import request from '@/plugins/axios'
const base = '/'

export function getLgActivityOrder(params) {
    return request({
        url: base + 'api/jd/activity/order/lg/cwget',
        method: 'get',
        params
    })
}

export function getMxActivityOrder(params) {
    return request({
        url: base + 'api/jd/activity/order/mx/cwget',
        method: 'get',
        params
    })
}